import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=8dc7cce2&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\immersive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc7cce2')) {
      api.createRecord('8dc7cce2', component.options)
    } else {
      api.reload('8dc7cce2', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=8dc7cce2&", function () {
      api.rerender('8dc7cce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home.vue"
export default component.exports